export const favoriteScript = (scriptId, remove) => {
  return {
    type: 'FAVORITE_SCRIPT',
    payload: { scriptId, remove },
  }
}

export const getScript = () => {
  return {
    type: 'GET_SCRIPT',
    payload: {},
  }
}

export const favoritedScript = (data) => {
  return {
    type: 'FAVORITED_SCRIPT',
    payload: data,
  }
}

export const favoriteError = (error) => {
  return {
    type: 'FAVORITE_ERROR',
    payload: error,
  }
}